import { Component, computed, input, signal } from '@angular/core';
import { TabComponent } from '../../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../../components/table/api-table/api-table.component';
import { ModalComponent } from '../../../../components/modal/modal.component';
import { TableRow } from '../../../../components/table/table.interface';

@Component({
  selector: 'app-evaluations-tab',
  imports: [TabLayoutComponent, APITableComponent, ModalComponent],
  providers: [{ provide: TabComponent, useExisting: EvaluationsTabComponent }],
  templateUrl: './evaluations-tab.component.html',
  styleUrl: './evaluations-tab.component.scss',
})
export class EvaluationsTabComponent extends TabComponent {
  override name = this.dictionaryService.get('Evaluations');

  userId = input.required<string>();

  endpoint = computed(
    () => `/evaluations/tables/user-evaluations/${this.userId()}`,
  );

  selectedEvaluationId = signal<string>('');
  selectedEvaluationTitle = signal<string>('');
  isDetailsModalOpen = signal<boolean>(false);

  public async main(): Promise<void> {}

  openEvaluationDetails = (row: TableRow): void => {
    const evaluationId = this.readStringValue(row, 'Id');

    if (!evaluationId) {
      return;
    }

    const evaluationName = this.readStringValue(row, 'Name') || this.name;
    const evaluationDate = this.readStringValue(row, 'Date');

    this.selectedEvaluationId.set(evaluationId);
    this.selectedEvaluationTitle.set(
      evaluationDate ? `${evaluationName} - ${evaluationDate}` : evaluationName,
    );
    this.isDetailsModalOpen.set(true);
  };

  onModalClose = (): void => {
    this.isDetailsModalOpen.set(false);
    this.selectedEvaluationId.set('');
    this.selectedEvaluationTitle.set('');
  };

  private readStringValue(row: TableRow, key: string): string {
    const value = row.value[key];

    if (typeof value === 'string' || typeof value === 'number') {
      return String(value);
    }

    return '';
  }
}